import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, IconButton, Paper } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Navbar from "../../components/Navbar";
import Aviso from "../../components/Aviso";
import "react-toastify/dist/ReactToastify.css";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DescriptionIcon from "@mui/icons-material/Description";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const nome = localStorage.getItem("nome");
  const searchParams = new URLSearchParams(location.search);
  const user = searchParams.get("user");
  const [pressed, setPressed] = useState(null);
  const [touchMoved, setTouchMoved] = useState(false);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("loggedIn");
    if (isLoggedIn) {
      toast.success(
        `Bem-vindo, ${nome ? nome.split(" ").slice(0, 2).join(" ") : "Usuário"}!`,
        {
          position: "bottom-center",
          autoClose: 2000,
        }
      );
      localStorage.removeItem("loggedIn");
    }
  }, [nome]);

  const handleNavigation = (categoria) => {
    if (!touchMoved) {
      if (user) {
        navigate(`/servicos/listar/${categoria}?user=${user}`);
      } else {
        navigate(`/servicos/listar/${categoria}`);
      }
    }
  };

  const handlePressStart = (categoria) => {
    setPressed(categoria);
    setTouchMoved(false);
  };

  const handleTouchMove = () => {
    setTouchMoved(true);
  };

  const handlePressEnd = (categoria) => {
    if (!touchMoved && pressed === categoria) {
      handleNavigation(categoria);
    }
    setPressed(null);
  };

  return (
    <>
      <Box>
        <Navbar />
        <Aviso />
        <Box
          sx={{
            p: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            mt: 2,
          }}
        >
          <Grid container spacing={3} justifyContent="center">
            {[
              { label: "Consultas", icon: <CalendarTodayIcon fontSize="large" />, color: "primary", category: "CONSULTA" },
              { label: "Exames", icon: <DescriptionIcon fontSize="large" />, color: "success", category: "EXAME" },
              { label: "Transporte", icon: <LocalShippingIcon fontSize="large" />, color: "warning", category: "TRANSPORTE" },
            ].map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.category}>
                <Paper
                  elevation={3}
                  role="button"
                  tabIndex={0}
                  aria-pressed={pressed === item.category}
                  aria-label={`Navegar para ${item.label}`}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 2,
                    height: {
                      xs: "25vh",
                      sm: "40vh",
                      md: "50vh",
                    },
                    cursor: "pointer",
                    transform: pressed === item.category ? "scale(0.95)" : "scale(1)",
                    transition: "transform 0.15s ease-in-out",
                    outline: pressed === item.category ? "2px solid #1976d2" : "none",
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.07)",
                    },
                    "&:focus": {
                      outline: "2px solid #1976d2",
                      outlineOffset: "2px",
                    },
                  }}
                  onTouchStart={() => handlePressStart(item.category)}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={() => handlePressEnd(item.category)}
                  onMouseDown={() => handlePressStart(item.category)}
                  onMouseUp={() => handlePressEnd(item.category)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handlePressEnd(item.category);
                    }
                  }}
                >
                  <IconButton
                    size="large"
                    color={item.color}
                    aria-label={`Ícone de ${item.label}`}
                  >
                    {item.icon}
                  </IconButton>
                  <Typography variant="h6">{item.label}</Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default Home;